import { useEffect } from "react";

import {
    PreloadedQuery,
    usePreloadedQuery,
    useLazyLoadQuery
} from "react-relay";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { agileArticleOneQuery } from "@/__generated_contentful__/agileArticleOneQuery.graphql";
import { agileArticleTwoQuery } from "@/__generated_contentful__/agileArticleTwoQuery.graphql";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { SitesContextProvider } from "@/components/sites-provider";
import {
    AgileArticleQueryData,
    AgileArticleOneQuery,
    AgileArticleTwoQuery,
    getAgileArticleQueryVars,
    shapeAgileArticleContentfulResponse
} from "@/contentful/graphql/agile-article";
import { AgileArticlePageTemplate } from "@/templates/agile-hub/src/agile-article-page.template";
import { AgileArticleProvider } from "@/templates/agile-hub/src/agile-article.provider";
import { AgileArticle } from "@/templates/agile-hub/types";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag.ts";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest.ts";

export type AgileArticlePageRelayProps = {
    agileArticle: AgileArticle | null;
    queryRef: PreloadedQuery<agileArticleOneQuery>;
    location: Location;
};

export const AgileArticlePage = ({
    agileArticle,
    queryRef,
    location
}: AgileArticlePageProps) => {
    const dataPartOne = usePreloadedQuery<agileArticleOneQuery>(
        AgileArticleOneQuery,
        queryRef
    );
    const dataPartTwo = useLazyLoadQuery<agileArticleTwoQuery>(
        AgileArticleTwoQuery,
        getAgileArticleQueryVars(location)
    );

    const combinedData = {
        articleDetailsCollection: {
            items: [
                {
                    ...dataPartOne.articleDetailsCollection?.items[0],
                    ...dataPartTwo.articleDetailsCollection?.items[0]
                }
            ]
        }
    } as AgileArticleQueryData;
    agileArticle = shapeAgileArticleContentfulResponse(combinedData);

    return (
        <SitesContextProvider>
            <SiteSelectorContextProvider
                analyticsPrefix="jira-software.ondemand" // TODO: Check if this is correct
                productKey={ProductKeys.JIRA_SOFTWARE}
            >
                <AgileArticleProvider agileArticle={agileArticle}>
                    <AgileArticlePageTemplate />
                </AgileArticleProvider>
            </SiteSelectorContextProvider>
        </SitesContextProvider>
    );
};
